// @ts-nocheck

import React, { useState, useEffect } from "react";
import { Form, Input, Button, Spin, Select } from "antd";
import styles from "./index.module.scss";

const { Option } = Select;

const Credentials = ({
  editConnection,
  setDestinationData,
  handleFinish,
  destinationData,
  setResetForms,
  resetForms,
  handlePrevious,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [fileType, setFileType] = useState(null); // State to manage the file type

  useEffect(() => {
    if (editConnection && Object.keys(editConnection).length > 0) {
      form.setFieldsValue(editConnection?.destination || destinationData);
      setFileType(editConnection?.destination?.fileType || null); // Set fileType from editConnection
    } else {
      form.resetFields();
      setFileType(null); // Reset fileType to null if initialValues is empty
    }
  }, [form, destinationData, editConnection]);

  // Handle form submission
  const onFinish = (values) => {
    setLoading(true);
    setResetForms(true);
    setDestinationData(values); // Set the destination data
    handleFinish(values);
    setLoading(false);
  };

  useEffect(() => {
    if (resetForms && editConnection == null) {
      form.resetFields();
      setFileType(null); // Reset fileType to null if initialValues is empty

      setResetForms(false); // Reset form state after reset
    }
  }, [resetForms, setResetForms, form]);

  return (
    <div>
      {loading && (
        <div className={styles.overlay}>
          <Spin size="large" />
        </div>
      )}
      <Form
        form={form}
        name="destination"
        layout="vertical"
        initialValues={{ remember: true }}
        onFinish={onFinish}
      >
        <Form.Item
          label="Host"
          name="host"
          rules={[{ required: true, message: "Please input your Host!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="User"
          name="user"
          rules={[{ required: true, message: "Please input your User!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true, message: "Please input your Password!" }]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          label="Output File Name"
          name="fileName"
          rules={[{ required: true, message: "Please input your File Name!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="DES_DIR"
          name="desDir"
          rules={[{ required: true, message: "Please input your DES_DIR!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="File Extension"
          name="fileType"
          rules={[{ required: true, message: "Please select a File Type!" }]}
        >
          <Select
            placeholder="Select a file type"
            onChange={(value) => {
              setFileType(value); // Update fileType state on selection
              form.setFieldsValue({ delimiter: undefined }); // Reset delimiter when changing file type
            }}
          >
            <Option value="csv">CSV</Option>
            <Option value="txt">Text</Option>
          </Select>
        </Form.Item>

        {fileType === "txt" && ( // Only show delimiter input if file type is Text
          <Form.Item
            label="Delimiter"
            name="delimiter"
            rules={[
              {
                validator: (_, value) => {
                  if (!value) {
                    return Promise.reject("Please input your Delimiter!");
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input placeholder="Enter delimiter (e.g., , or |)" />
          </Form.Item>
        )}

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Button onClick={handlePrevious}>Previous</Button>
          <Button type="primary" htmlType="submit">
            Finish
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default Credentials;
